'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { removeAdminRole } from '../../services/adminService';
import { TErrorResponse } from '../../types/error-response';

const useRemoveAdminRole = () => {
    const queryClient = useQueryClient();
    const { data, mutate, isPending, error, isSuccess, isError } = useMutation<
        unknown,
        TErrorResponse,
        string,
        unknown
    >({
        mutationFn: (roleId) => removeAdminRole(roleId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['get-admins'] });
        },
    });
    return { data, mutate, isPending, error, isSuccess, isError };
};

export default useRemoveAdminRole;
